import React, { useState, useEffect, useRef } from 'react';
import '../component.scss';
import SearchField from './SearchField';
import SearchDropdownList from './SearchDropdownList';
import SearchDropdownMultiselectList from './SearchDropdownMultiselectList';
import SearchDropdownVirtualizedList from './SearchDropdownVirtualizedList';
import SearchRange from './SearchRange';
import { FiCheckSquare, FiSquare } from 'react-icons/fi';

const SearchWidget = ({
  value,
  dictionary = {},
  items,
  label,
  title = '',
  width = 220,
  placeholder = true,
  buttonDone = true,
  buttonReset = false,
  type = 'base',
  onChoose,
  hasFilter = false,
  cssClass = '',
  onReset,
  defaultValue = null,
  isChanged = false,
  flags = false,
  children,
  country,
  onHide,
  isOperatorHidden = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(
    country ? items[country] : items
  );
  const [wasChanged, setWasChanged] = useState(isChanged);
  const [isHidden, setHidden] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
      if (e.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setHidden(isOperatorHidden);
  }, [isOperatorHidden]);

  const setValue = (value) => {
    console.log('set value:', cssClass);
    setIsOpen(false);
    onChoose(value);
    setSearchTerm('');
    setFilteredOptions(country ? items[country] : items);
    if (!value && value !== 0) {
      setWasChanged(false);
    } else {
      setWasChanged(true);
    }
  };

  const onChooseMultiselect = (value) => {
    onChoose(value);
    setWasChanged(true);
  };

  const onChooseRange = (a, b) => {
    onChoose(a, b);
    setWasChanged(true);
  };

  const reset = () => {
    if (cssClass === 'services') {
      onReset();
      setWasChanged(false);
    } else {
      setValue([]);
    }
    setIsOpen(false);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    const filtered = items.filter((option) =>
      option.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredOptions(filtered);
  };

  return (
    <div ref={dropdownRef} className={`search-widget ${cssClass}`}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={`search-field ${wasChanged}`}
      >
        <SearchField
          cssClass={cssClass}
          placeholder={placeholder}
          label={label}
          title={title}
          value={value}
          dictionary={dictionary}
        />
      </div>
      {isOpen ? (
        <div className="popup-list" style={{ width: width }}>
          {hasFilter || buttonDone || buttonReset ? (
            <>
              {children ? children : null}
              <div className="filterbar">
                {hasFilter && (
                  <input
                    type="text"
                    placeholder={label}
                    autoFocus
                    className="filterinput"
                    value={searchTerm}
                    onChange={handleInputChange}
                  />
                )}
                {buttonDone && (
                  <button
                    className="btn btn_submit"
                    onClick={() => setIsOpen(false)}
                  >
                    Готово
                  </button>
                )}
                {buttonReset && (
                  <button className="btn btn_reset" onClick={reset}>
                    Сбросить
                  </button>
                )}
                {label === 'туроператор' ? (
                  <button
                    className="btn btn_hide"
                    onClick={() => onHide(!isHidden)}
                  >
                    {!isHidden ? (
                      <FiSquare />
                    ) : (
                      <FiCheckSquare color="#db4294" />
                    )}
                    <p className="">Скрыть</p>
                  </button>
                ) : null}
              </div>
            </>
          ) : null}
          {type === 'range' && (
            <SearchRange
              value={value}
              onChoose={onChooseRange}
              onClose={() => setIsOpen(false)}
            />
          )}
          {type === 'multiselect' && (
            <SearchDropdownMultiselectList
              value={value}
              items={items}
              onChoose={(value) => onChooseMultiselect(value)}
            />
          )}
          {type === 'virtualized' && (
            <SearchDropdownVirtualizedList
              value={value}
              items={items}
              onChoose={onChoose}
            />
          )}
          {type === 'select' && (
            <SearchDropdownList
              items={filteredOptions}
              value={value}
              onChoose={setValue}
              country={country}
            />
          )}
        </div>
      ) : null}
    </div>
  );
};

export default SearchWidget;
